import * as React from 'react';
import connectWithRouter from '../../../shared/components/redux/connectWithRouter';
import {
  getItemId,
  getVariationSpecificsForEditDialog,
  prepareVariationSpecificsSetForEditDialog,
} from './ebayListingSelectors';
import EditVariationOptionsDialog, {
  aspectValuesType,
} from '../../../shared/components/Dialogs/EditVariationOptionsDialog/EditVariationOptionsDialog';
import {EBAY_LISTINGS_ACTIONS_TYPES} from '../../../shared/ActionsManager/ActionsTypes';
import {ACTION_DISPLAY_TYPES} from '../../../shared/ActionsManager/ActionsManagerConsts';
import EbayListingsActions from '../../../shared/ActionsManager/EbayListingsActions/EbayListingsActions';
import {SpecificFormDialogProps} from 'cl-dialogs/FormDialog';

export interface ListerVariationOptionsDialogProps {
  itemId?: string[];
  recommendedVariationSpecifics?: object;
  initialVariationsSpecificSet?: aspectValuesType;
}

const ListerVariationOptionsDialog: React.FunctionComponent<
  SpecificFormDialogProps<{}, ListerVariationOptionsDialogProps>
> = ({itemId, recommendedVariationSpecifics, initialVariationsSpecificSet, ...other}) => {
  return (
    <EditVariationOptionsDialog
      recommendedVariationSpecifics={recommendedVariationSpecifics}
      initialVariationsSpecificSet={initialVariationsSpecificSet}
      actions={
        <EbayListingsActions
          types={[EBAY_LISTINGS_ACTIONS_TYPES.EDIT_VARIATION_OPTIONS]}
          displayType={ACTION_DISPLAY_TYPES.FLAT_BUTTON}
          listingsIds={[itemId]}
        />
      }
      formName={EBAY_LISTINGS_ACTIONS_TYPES.EDIT_VARIATION_OPTIONS}
      {...other}
    />
  );
};

export default connectWithRouter(
  state => ({
    itemId: getItemId(state),
    recommendedVariationSpecifics: getVariationSpecificsForEditDialog(state),
    initialVariationsSpecificSet: prepareVariationSpecificsSetForEditDialog(state),
  }),
  {}
)(ListerVariationOptionsDialog);
